var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.586 5.586c-.781.781-.781 2.047 0 2.828l3.585 3.586-3.585 3.586c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586l6.415-6.414-6.415-6.414c-.78-.781-2.048-.781-2.828 0z"}));
}

Chevron.defaultProps = {"fill":"#000000","width":"800px","height":"800px","viewBox":"0 0 24 24","version":"1.2","baseProfile":"tiny"};

module.exports = Chevron;

Chevron.default = Chevron;
